import KpiInfoTooltip from './KpiInfoTooltip'
import { OPTIMAL_POSTING_METRICS_HELP_SECTIONS } from '../utils/optimalPostingTimesUtils'

export default function OptimalPostingTimesPanelTitle({ title, statsLine }) {
  return (
    <span className="optimalPostingTimesPanelTitle">
      <span className="optimalPostingTimesPanelTitleLead">
        <span className="optimalPostingTimesPanelTitleMain">{title}</span>
        <KpiInfoTooltip
          sections={OPTIMAL_POSTING_METRICS_HELP_SECTIONS}
          aria-label="Posting time performance metrics"
          className="optimalPostingTimesPanelTitleInfo"
          portaled
          placement="bottom"
        />
      </span>
      {statsLine ? (
        <span className="optimalPostingTimesPanelTitleStats dashboard-tabular-nums">{statsLine}</span>
      ) : null}
    </span>
  )
}
